const pageNo = 1;
const pageSize = 10;

const PaginationPara = {
  pageNo,
  pageSize,
};

export default PaginationPara;
